import { render, staticRenderFns } from "./ConfirmationControls.vue?vue&type=template&id=3174434d"
import script from "./ConfirmationControls.vue?vue&type=script&lang=js"
export * from "./ConfirmationControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports